export default class Purchase {

    constructor(object, template) {
        this.object = object;
        this.clone = template.content.cloneNode(true);
    }

    element() {
        let modal_body = this.clone.querySelector('.tvod-content');
        if ( modal_body ) {
            let cover_art = modal_body.querySelector('.tvod-cover-art');
            cover_art.setAttribute('src', this.object.coverArt() );

            let name = modal_body.querySelector('.tvod-name');
            name.innerHTML = this.object.name();

            let series_name = modal_body.querySelector('.tvod-series-name');
            series_name.innerHTML = this.object.seriesName();

            let transactions= ['rent', 'buy'];
            for( let i in transactions ) {
                let purchase_amount = this.object.data['purchase'][transactions[i]];
                let amount = modal_body.querySelector('.tvod-' + transactions[i] + '-amount');
                amount.innerHTML = purchase_amount;
            }

            return modal_body;
        }

        return null;
    }

    loadForm(container) {
        let purchase = this;
        let staleError = document.getElementById('modal-error');
        if (staleError && staleError.parentNode) {
            staleError.parentNode.removeChild(staleError);
        }
        if (!container || !purchase.object.tvodFormUrl) {
            return Promise.resolve();
        }

        let retryMessage = 'Please try again.';
        let tvodText = purchase.object.constants &&
            purchase.object.constants.text &&
            purchase.object.constants.text.modal &&
            purchase.object.constants.text.modal.movie_details &&
            purchase.object.constants.text.modal.movie_details.tvod;
        if (tvodText && tvodText.purchase_form_retry) {
            retryMessage = tvodText.purchase_form_retry;
        }

        return fetch(purchase.object.tvodFormUrl(), { credentials: 'same-origin' }).then(function (response) {
            if (!response.ok) {
                throw new Error('purchase form request failed');
            }
            return response.text();
        }).then(function (html) {
            container.innerHTML = html;
            let form = container.querySelector('form');
            if (form) {
                form.action = purchase.object.tvodUrl();
                purchase.applyClickedTransactionType(form);
            }
        }).catch(function () {
            container.innerHTML = '<div class="lead">' + retryMessage + '</div>';
        });
    }

    applyClickedTransactionType(form) {
        let detail = window.content_detail;
        let chosen = detail && detail.current;
        if (chosen !== 'rent' && chosen !== 'buy') {
            return;
        }
        let input = form.querySelector('[name="transaction_type"]');
        if (input && input.value === '') {
            input.value = chosen;
        }
    }

}